import { jsx as a, jsxs as f } from "react/jsx-runtime";
import { c as p } from "../../index-Cu0xwYjD.js";
import { s as e } from "../../TabSet.module-C8hFDW4m.js";
import { C as d } from "../../floating-ui.react-DxYXKqW-.js";
import { propagateTestid as b } from "../../utils/helpers.js";
import { TabSetLayout as c } from "./TabSet.types.js";
import { IressTabSetProvider as S } from "./TabSetProvider.js";
import { TabSetPanel as T } from "./components/TabSetPanel.js";
const n = ({
  children: o,
  className: s,
  defaultSelected: i,
  layout: m = "top-left",
  onChange: r,
  selected: l,
  ...t
}) => /* @__PURE__ */ a(
  S,
  {
    onChange: r,
    defaultSelected: i,
    selected: l,
    children: /* @__PURE__ */ f(
      "div",
      {
        className: p(s, e.tabSet, {
          [e[`layout--${m}`]]: !!m
        }),
        ...t,
        children: [
          o && /* @__PURE__ */ a(
            d,
            {
              render: /* @__PURE__ */ a("div", { className: e.list, role: "tablist" }),
              loop: !1,
              children: o
            }
          ),
          o && /* @__PURE__ */ a(
            T,
            {
              "data-testid": b(t == null ? void 0 : t["data-testid"], "panel")
            }
          )
        ]
      }
    )
  }
);
n.Layout = c;
export {
  n as IressTabSet
};
